import React from "react"
import { makeStyles } from '@material-ui/core/styles';

import mixin from '../utils/mixin'

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';

import MomentUtils from '@date-io/moment';
import {　MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';

import { Line } from 'react-chartjs-2';


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  tide: {
    paddingBottom: theme.spacing(2),
  },
  day: {
    paddingBottom: theme.spacing(5),
  },
  content: {
    paddingBottom: theme.spacing(2),
  },
  buttonArea: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  tideArea: {
    paddingBottom: theme.spacing(6),
  }
}));

export const Tide = ({ data, updateParams, currentParams }) => {
  const classes = useStyles();

  const params = [...new URLSearchParams(currentParams).entries()].reduce((obj, e) => ({...obj, [e[0]]: e[1]}), {});
  let currentDate = new Date();
  if (params.date) {
    currentDate = mixin.stringFromDate(params.date)
  }

  console.log(currentDate)
  const [selectedDate, setSelectedDate] = React.useState(currentDate);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    updateParams(`&date=${date.format("YYYYMMDD")}&term=7`)
  };

  const tide = data.loc.tide.map((a, i) => {
    let labels = [];
    let datasets = [];
    let colors = [];

    const currentDate = new Date().getHours();

    for ( const [index, item] of a["level"].entries() ) {
      labels.push(item["-hr"])
      datasets.push(parseInt(item["-ht"]))

      const color = (a.tdate === mixin.getCurrentDateString() && currentDate === index) ? "red" : "#1a237e";
      colors.push(color);
    }

    const graphData = {
      labels: labels,
      datasets: [{
        data: datasets,
        label: mixin.formatDate(a["tdate"], true),
        backgroundColor: 'rgba(26,35,126, 0.4)',
        fill: true,
        borderColor: '#1a237e',
        borderDashOffset: 0.0,
        borderJoinStyle: 'miter',
        pointBorderColor: colors,
        pointBackgroundColor: colors,
        pointHoverBackgroundColor: '#1a237e',
        pointHoverBorderColor: 'rgba(220,220,220,1)',
      }],
    }
    return (
      <div key={`tide-${a["tdate"]}`} className={classes.tideArea}>
        <Grid
          spacing={3}
          container
          align="center"
          className={classes.content}
        >
          <Grid item xs={4} sm={2}>
            <Typography variant="body1" component="p">
              {mixin.formatDate(a["tdate"], true)}
            </Typography>
            <Typography variant="body1" component="p">
              {a["tphase"]}
            </Typography>
          </Grid>
          <Grid item xs={4} sm={2}>
            <Typography variant="body1" component="p">
              満潮
            </Typography>
            <Typography variant="body1" component="p">
              {`${a["ht1"]} ${a["hd1"]}`}
            </Typography>
            {
              a["ht2"] && <Typography variant="body1" component="p">
                {`${a["ht2"]} ${a["hd2"]}`}
              </Typography>
            }
          </Grid>
          <Grid item xs={4} sm={2}>
            <Typography variant="body1" component="p">
              干潮
            </Typography>
            <Typography variant="body1" component="p">
              {`${a["lt1"]} ${a["ld1"]}`}
            </Typography>
            {
              a["lt2"] && <Typography variant="body1" component="p">
                {`${a["lt2"]} ${a["ld2"]}`}
              </Typography>
            }
          </Grid>
          <Grid item xs={4} sm={2}>
          </Grid>
          <Grid item xs={4} sm={2}>
            <Typography variant="body1" component="p">
              {`日出：${a["sr"]}`}
            </Typography>
            <Typography variant="body1" component="p">
              {`日入：${a["ss"]}`}
            </Typography>
          </Grid>
          <Grid item xs={4} sm={2}>
            <Typography variant="body1" component="p">
              {`月出：${a["mr"]}`}
            </Typography>
            <Typography variant="body1" component="p">
              {`月入：${a["ms"]}`}
            </Typography>
          </Grid>
        </Grid>
        <Grid
         container
         spacing={3}
         align="center"
         alignItems="center"
         className={classes.content}
        >
          <Grid item xs={12} sm={12} key={`tide-graph-${a["tdate"]}`}>
            <Line data={graphData} />
          </Grid>
        </Grid>
        <Divider />
      </div>
    )
  });
  return (
    <React.Fragment>
      <div id="tide" className={classes.tide}>
        <Grid
          container
          direction="row"
          justify="flex-end"
          alignItems="center"
        >
          <Grid item xs={8} sm={2} className={classes.buttonArea}>
            <MuiPickersUtilsProvider utils={MomentUtils}>
              <Grid container justify="space-around">
                <KeyboardDatePicker
                  margin="normal"
                  id="date-picker-dialog"
                  label="日付の選択"
                  format="YYYY/MM/DD"
                  value={selectedDate}
                  onChange={handleDateChange}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
            </MuiPickersUtilsProvider>
          </Grid>
        </Grid>
        <Divider />
        {tide}
      </div>

    </React.Fragment>
  );
}

export default Tide;